
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import LineChart from '@/components/Charts/LineChart.vue'
import MixedChart from '@/components/Charts/MixedChart.vue'
import { IStatiseicsData } from '@/api/types'
import { getStatisticsList } from '@/api/statistics'
@Component({
  name: 'Dashboard',
  components: {
    LineChart,
    MixedChart
  }
})
export default class extends Vue {
  private list: IStatiseicsData[] = []
  private listLoading = true
  private dataTime = ''
  private total = 0
  private listQuery = {
    page: 1,
    pagesize: 10
  }
  private dataItem = {
    name: '报警数',
    xAxis: ['13:00', '13:05', '13:10', '13:15', '13:20', '13:25', '13:30', '13:35', '13:40', '13:45', '13:50', '13:55'],
    data: [12, 11, 12, 15, 12, 16, 12, 22, 18, 19, 13, 15]
  }
  created() {
    this.getList()
  }
  // 列表数据获取
  private async getList() {
    this.listLoading = true
    const { data } = await getStatisticsList(this.listQuery)
    this.list = data.items
    this.total = data.total
    this.dataTime = data.time
    this.listLoading = false
  }
  // 分页切换
  private async handleCurrentChange(page:number) {
    this.listQuery.page = page
    this.getList()
  }
}
